import { Query, QueryClient, useQueryClient } from "@tanstack/react-query";

export function useInvalidate() {
  const qc = useQueryClient();
  return (keys) => invalidateQueriesBySubstrings(qc, keys);
}

function invalidateQueriesBySubstrings(queryClient, keySubstrings) {
  return queryClient.invalidateQueries({
    predicate: (query) =>
      keySubstrings.some((substr) =>
        query.queryKey.some(
          (key) => typeof key === "string" && key.includes(substr)
        )
      ),
  });
}
